import { SettingsStorageService } from '../../auth/services/settings-storage.service';
import { HdWizardStepTrackerStep, HdWizardStorage, WizardVersion } from '../wizard-native/interface';
import useService from '../../injector/hooks/useService';

export function useWizardStorage(): HdWizardStorage {
  const settingsStorageService = useService(SettingsStorageService);

  const getStoredData = (key: string) => {
    return settingsStorageService.getSettings(key);
  };

  const store = (key: string, data: { steps: HdWizardStepTrackerStep[], data: any, version: WizardVersion }) => {
    settingsStorageService.applySettings(key, data);
  };

  return {
    getStoredData,
    store
  };
}
